import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal/Modal';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import SmallCheckBox from '../SmallCheckBox/SmallCheckBox';
import SubscriptionsAPI from '../../api/SubscriptionsAPI';
import { toastService } from '../../services/ToastService';

type Props = {
  onClose: (dontOfferUntilNextMonth: boolean) => void;
};

function SmsLimitReachedModal({ onClose }: Props) {
  const { t } = useTranslation();
  const [dontOfferChecked, setDontOfferChecked] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleGoToBrandPlan = async () => {
    setIsRedirecting(true);
    try {
      const response = await SubscriptionsAPI.createCheckoutOrPortal('store');
      if (response.data?.url) {
        window.location.href = response.data.url;
      } else {
        toastService.showToast(t('global.error', 'Something went wrong'), 'error');
        setIsRedirecting(false);
      }
    } catch (error) {
      console.error('Failed to start SMS-limit upgrade checkout', { error });
      toastService.showToast(t('global.error', 'Something went wrong'), 'error');
      setIsRedirecting(false);
    }
  };

  return (
    <Modal
      modalTitle="calendar.sms_limit.title"
      canClose
      onClose={() => onClose(dontOfferChecked)}
    >
      <>
        <p className="py-3">{t('calendar.sms_limit.body', {
          storePlan: t('pricing.store.name'),
          brandPlan: t('pricing.brand.name'),
        })}</p>
        <p className="text-sm text-muted-foreground py-2">
          {t('calendar.sms_limit.email_note')}
        </p>
        <div className="mt-4 mb-2">
          <SmallCheckBox
            label="calendar.sms_limit.dont_offer_until_next_month"
            defaultValue={false}
            onChange={(e) => setDontOfferChecked(e.target.checked)}
          />
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-5">
          <SecondaryButton
              text={t('global.close') ?? ''}
              fn={() => onClose(dontOfferChecked)}
            />
          <PrimaryButton
            text={(isRedirecting
              ? t('subscription.loading', 'Loading...')
              : t('calendar.sms_limit.upgrade_link', { storePlan: t('pricing.store.name') })
            ) ?? ''}
            fn={handleGoToBrandPlan}
            isDisabled={isRedirecting}
            isLoading={isRedirecting}
          />
        </div>
      </>
    </Modal>
  );
}

export default SmsLimitReachedModal;
